import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import classNames from 'classnames';
import {
  // LineChart,
  // Line,
  BarChart,
  Bar,
  // PieChart,
  // Pie,
  // Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer
} from 'recharts';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import MenuDrawerGroup from '../../components/MenuDrawerGroup';
import ShopInGroupTableGroup from '../organisms/ShopInGroupTableGroup';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import {
  getReportShopGroupTotalAmount,
  getReportShopGroupByDayAmount,
  getReportShopGroupPlatForm,
  getReportShopGroupByUserType,
  getReportShopGroupByDayDownload,
  getReportShopGroupCampaignTotalAmount,
  getReportShopGroupCampaignByDayAmount,
  getReportShopGroupGochiKidTotalAmount,
  getReportShopGroupGochiKidByDayAmount
} from '../../actions/Reports';
import ExPaginationGroup from '../../components/molecules/ExPaginationGroup';

const drawerWidth = 240;

function CustomizedAxisTick({ x, y, payload }) {
  const [year, date] = payload.value.split('\n');
  return (
    <g transform={`translate(${x},${y})`}>
      <text x={0} y={0} dy={16} fill="#666">
        <tspan textAnchor="middle" x="0">
          {year}
        </tspan>
        <tspan textAnchor="middle" x="0" dy="20">
          {date}
        </tspan>
      </text>
    </g>
  );
}

CustomizedAxisTick.propTypes = {
  x: PropTypes.number.isRequired,
  y: PropTypes.number.isRequired,
  payload: PropTypes.objectOf(PropTypes.object).isRequired
};

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: 36
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap'
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  content: {
    flexGrow: 1,
    padding: 40,
    paddingTop: 15,
    width: 'calc(100% - 240px)'
  },
  // end sidebar
  paperWhite: {
    padding: 20,
    marginBottom: 40
  },
  titlePaper: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  linkRight: {
    marginLeft: 'auto',
    fontSize: 14,
    fontWeight: 'bold'
  },
  rowTitle: {
    // marginBottom: 10,
    display: 'flex',
    alignItems: 'flex-end'
  },
  boxBlueBg: {
    padding: 20,
    backgroundColor: '#EAF6FF'
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 15
  },
  subTitle: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 10
  },
  normalText: {
    fontWeight: '600',
    fontSize: 12,
    marginBottom: 8
  },
  rowBox: {
    display: 'flex',
    marginLeft: '-20px',
    marginRight: '-20px'
  },
  rowColTwo: {
    width: '50%',
    paddingLeft: 10,
    paddingRight: 10
  },
  rowColTwoRight: {
    borderLeft: '1px solid #D1D1D1'
  },
  rowInCol: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  colTwoInCol: {
    width: '50%',
    paddingLeft: 10,
    paddingRight: 10
  },
  rowColThree: {
    width: '75%',
    paddingLeft: 10,
    paddingRight: 10
  },
  colThreeInCol: {
    width: 'calc(100% / 3)',
    paddingLeft: 10,
    paddingRight: 10
  },
  textExplain: {
    paddingLeft: 10,
    paddingRight: 10,
    fontSize: 10,
    marginTop: 15
  },
  cardAmount: {
    borderRadius: 0
  },
  cardHeader: {
    height: 32,
    backgroundColor: '#2196F3',
    padding: '8px 15px',
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 'bold',
    whiteSpace: 'no-wrap'
  },
  cardContent: {
    padding: '10px 15px',
    paddingBottom: '10px !important'
  },
  titleAmount: {
    fontSize: 40,
    fontWeight: 'bold',
    whiteSpace: 'no-wrap'
  },
  unit: {
    fontSize: 20
  },
  titleSm: {
    fontSize: 20,
    marginBottom: 8,
    fontWeight: 'bold'
  },
  mb20: {
    marginBottom: 20
  },
  colFull: {
    width: '100%',
    paddingLeft: 10,
    paddingRight: 10
  },
  customDateDiv: {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'flex-end'
  },
  textField: {
    marginLeft: 10
  },
  title20: {
    fontSize: 20,
    fontWeight: 'bold'
  },
  rowTitleButton: {
    marginTop: 30,
    marginBottom: 20
  },
  buttonRight: {
    backgroundColor: '#ffffff',
    width: 170
  },
  titleRow: {
    display: 'flex',
    alignItems: 'center'
  },
  marginLeftAuto: {
    marginLeft: 'auto'
  },
  titleBar: {
    fontWeight: 'bold',
    fontSize: 20,
    // marginBottom: 15,
    color: '#000000',
    padding: 20
  },
  chartDataFlex: {
    marginBottom: 40
  },
  dotColor: {
    display: 'inline-block',
    width: 9,
    height: 9,
    borderRadius: 6,
    marginRight: 5
  },
  boxTooltip: {
    padding: 15,
    fontSize: 12,
    color: '#000000'
  },
  labelTooltip: {
    fontWeight: 'bold',
    marginBottom: 5
  },
  rowTooltip: {
    marginTop: 8
  },
  bold: {
    fontWeight: 'bold'
  }
});

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      groups: state.groups.groups
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getReportShopGroupTotalAmount,
          getReportShopGroupByDayAmount,
          getReportShopGroupPlatForm,
          getReportShopGroupByUserType,
          getReportShopGroupByDayDownload,
          getReportShopGroupCampaignTotalAmount,
          getReportShopGroupCampaignByDayAmount,
          getReportShopGroupGochiKidTotalAmount,
          getReportShopGroupGochiKidByDayAmount
        },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openShopGroupTable', 'updateOpenShopGroupTable', false),
  withState('openShopGroupFullTable', 'updateOpenShopGroupFullTable', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withState('pageShopGroup', 'setPageShopGroup', 1),
  withState('pageShopGroupFull', 'setPageShopGroupFull', 1),
  withState('rowsShopPerPage', 'setShopRowsPerPage', 10),
  withState('rowsPerPage', 'setRowsPerPage', 20),
  withState('dateFrom', 'setDateFrom', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment()
      .date(1)
      .format('YYYY-MM-DD');
  }),
  withState('dateTo', 'setDateTo', () => {
    return moment()
      .endOf('month')
      .format('YYYY-MM-DD');
  }),
  withState('dateToday', 'setDateToday', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('MM/DD');
  }),
  withState('dateSearchToday', 'setDateSearchToday', () => {
    moment.tz.setDefault('Asia/Tokyo');
    return moment().format('YYYY-MM-DD');
  }),
  withState('groupAmountTotal', 'setGroupAmountTotal', {}),
  withState('groupAmountByDay', 'setGroupAmountByDay', {}),
  withState('groupAmountByDayFull', 'setGroupAmountByDayFull', {}),
  withState('amountShopPlatForm', 'setAmountShopPlatForm', []),
  withState('amountShopUserType', 'setAmountShopUserType', []),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'updateLoading', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeShopRowsPerPage: props => event => {
      props.setShopRowsPerPage(event.target.value);
    },
    handleChangeShopGroupToDayPage: props => (event, page, limit) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        page: page || 1,
        limit: limit || props.rowsShopPerPage,
        gochiCreateFrom: props.dateSearchToday,
        gochiCreateTo: props.dateSearchToday
      };
      if (
        (props.account.groupType === 'CAMPAIGN' ||
          props.account.groupType === 'OTHERS') &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupCampaignByDayAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
              props.setGroupAmountByDay(data.payload);
              props.updateOpenShopGroupTable(true);
            }
          });
      } else if (
        props.account.groupType === 'GOCHI_KID' &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupGochiKidByDayAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
              props.setGroupAmountByDay(data.payload);
              props.updateOpenShopGroupTable(true);
            }
          });
      } else {
        props.actions.getReportShopGroupByDayAmount(searchKey).then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
            props.setGroupAmountByDay(data.payload);
            props.updateOpenShopGroupTable(true);
          }
        });
      }

      props.setPageShopGroup(page || 1);
    },
    handleChangeShopGroupByDayPage: props => (
      event,
      page,
      limit,
      firstLoad,
      fromDate,
      toDate
    ) => {
      const table = document.getElementById('scrollTableId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        page,
        limit: limit || props.rowsShopPerPage,
        gochiCreateFrom: fromDate || props.dateFrom,
        gochiCreateTo: toDate || props.dateTo
      };
      if (props.account && props.account.groupDisplayLimit === 1) {
        return;
      }
      if (
        (props.account.groupType === 'CAMPAIGN' ||
          props.account.groupType === 'OTHERS') &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupCampaignByDayAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
              // props.setGroupAmountByDay(data.payload);
              // props.updateOpenShopGroupTable(true);
              if (firstLoad) {
                props.setGroupAmountByDayFull(data.payload);
                props.updateOpenShopGroupFullTable(true);
                props.setPageShopGroupFull(page);
              }
            }
          });
      } else if (
        props.account.groupType === 'GOCHI_KID' &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupGochiKidByDayAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
              // props.setGroupAmountByDay(data.payload);
              // props.updateOpenShopGroupTable(true);
              if (firstLoad) {
                props.setGroupAmountByDayFull(data.payload);
                props.updateOpenShopGroupFullTable(true);
                props.setPageShopGroupFull(page);
              }
            }
          });
      } else {
        props.actions.getReportShopGroupByDayAmount(searchKey).then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
            // props.setGroupAmountByDay(data.payload);
            // props.updateOpenShopGroupTable(true);
            if (firstLoad) {
              props.setGroupAmountByDayFull(data.payload);
              props.updateOpenShopGroupFullTable(true);
              props.setPageShopGroupFull(page);
            }
          }
        });
      }
      props.setPageShopGroup(page);
    },
    handleChangeShopGroupFullByDayPage: props => (event, page, limit) => {
      if (props.account && props.account.groupDisplayLimit === 1) {
        return;
      }
      const table = document.getElementById('scrollTableFullId');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        page,
        limit: limit || props.rowsShopPerPage,
        gochiCreateFrom: props.dateFrom,
        gochiCreateTo: props.dateTo
      };
      if (
        (props.account.groupType === 'CAMPAIGN' ||
          props.account.groupType === 'OTHERS') &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupCampaignByDayAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
              props.setGroupAmountByDayFull(data.payload);
              props.updateOpenShopGroupFullTable(true);
            }
          });
      } else if (
        props.account.groupType === 'GOCHI_KID' &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupGochiKidByDayAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
              props.setGroupAmountByDayFull(data.payload);
              props.updateOpenShopGroupFullTable(true);
            }
          });
      } else {
        props.actions.getReportShopGroupByDayAmount(searchKey).then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_AMOUNTS_SUCCESS') {
            props.setGroupAmountByDayFull(data.payload);
            props.updateOpenShopGroupFullTable(true);
          }
        });
      }
      props.setPageShopGroupFull(page);
    },
    handleChangeAmountTotalPage: props => (fromDate, toDate) => {
      const table = document.getElementById('scrollTableIdTotal');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        gochiCreateFrom: fromDate || props.dateFrom,
        gochiCreateTo: toDate || props.dateTo
      };

      if (
        (props.account.groupType === 'CAMPAIGN' ||
          props.account.groupType === 'OTHERS') &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupCampaignTotalAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS') {
              props.setGroupAmountTotal(data.payload);
            }
          });
      } else if (
        props.account.groupType === 'GOCHI_KID' &&
        props.account.fukuokaFlag !== 1
      ) {
        props.actions
          .getReportShopGroupGochiKidTotalAmount(searchKey)
          .then(data => {
            if (data.error === true && data.payload.status === 403) {
              sendLogin(props);
            }
            if (data.type === 'GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS') {
              props.setGroupAmountTotal(data.payload);
            }
          });
      } else {
        props.actions.getReportShopGroupTotalAmount(searchKey).then(data => {
          if (data.error === true && data.payload.status === 403) {
            sendLogin(props);
          }
          if (data.type === 'GET_REPORT_SHOP_GROUP_TOTAL_AMOUNTS_SUCCESS') {
            props.setGroupAmountTotal(data.payload);
          }
        });
      }
    },
    handleChangeShopPlatFormPage: props => (fromDate, toDate) => {
      if (props.account && props.account.groupDisplayLimit === 1) {
        return;
      }
      const table = document.getElementById('scrollTableIdTotal');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        page: 1,
        limit: 20,
        gochiCreateFrom: fromDate || props.dateFrom,
        gochiCreateTo: toDate || props.dateTo
      };

      props.actions.getReportShopGroupPlatForm(searchKey).then(data => {
        if (data.error === true && data.payload.status === 403) {
          sendLogin(props);
        }
        if (data.type === 'GET_REPORT_SHOP_GROUP_PLATFORM_SUCCESS') {
          props.setAmountShopPlatForm(data.payload);
        }
      });
    },
    handleChangeShopUserTypePage: props => (fromDate, toDate) => {
      if (props.account && props.account.groupDisplayLimit === 1) {
        return;
      }
      const table = document.getElementById('scrollTableIdTotal');
      if (table !== null) {
        table.scrollTop = 0;
      }
      const searchKey = {
        page: 1,
        limit: 20,
        gochiCreateFrom: fromDate || props.dateFrom,
        gochiCreateTo: toDate || props.dateTo,
        order: 'shopNameAsc'
      };

      props.actions.getReportShopGroupByUserType(searchKey).then(data => {
        if (data.error === true && data.payload.status === 403) {
          sendLogin(props);
        }
        if (data.type === 'GET_REPORT_SHOP_GROUP_USER_TYPE_SUCCESS') {
          props.setAmountShopUserType(data.payload);
        }
      });
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.handleChangeAmountTotalPage();
      this.props.handleChangeShopPlatFormPage();
      this.props.handleChangeShopUserTypePage();
      this.props.handleChangeShopGroupToDayPage();
      this.props.handleChangeShopGroupByDayPage(
        null,
        1,
        this.props.rowsShopPerPage,
        true
      );
    }
  })
);

const SummaryReportGroup = enhance(
  ({
    classes,
    account,
    openShopGroupTable,
    pageShopGroup,
    pageShopGroupFull,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    dateToday,
    groupAmountTotal,
    groupAmountByDay,
    groupAmountByDayFull,
    rowsShopPerPage,
    setRowsShopPerPage,
    handleChangeShopRowsPerPage,
    handleChangeShopGroupFullByDayPage,
    amountShopPlatForm,
    amountShopUserType,
    handleChangeAmountTotalPage,
    handleChangeShopPlatFormPage,
    handleChangeShopUserTypePage,
    handleChangeShopGroupByDayPage,
    handleChangeShopGroupToDayPage,
    actions,
    loading,
    updateLoading,
    openProgress,
    updateOpenProgress,
    checkSession
  }) => {
    const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    const isSecretariat =
      typeof account !== 'undefined' && account.role === 'SECRETARIAT';
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const isGochiKidGroup = isGroup && account.groupType === 'GOCHI_KID';
    const roles = {
      isGroup,
      isSecretariat
    };

    const changeDate = (fromDate, toDate) => {
      handleChangeAmountTotalPage(fromDate, toDate);
      handleChangeShopPlatFormPage(fromDate, toDate);
      handleChangeShopUserTypePage(fromDate, toDate);
      handleChangeShopGroupByDayPage(
        null,
        1,
        rowsShopPerPage,
        true,
        fromDate,
        toDate
      );
    };

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const url = URL.createObjectURL(new Blob([blob], { type: 'text/csv' }));
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();
        linkEl.parentNode.removeChild(linkEl);
        // iOSのクリックイベント対策
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      updateLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .getReportShopGroupByDayDownload({
          gochiCreateFrom: dateFrom,
          gochiCreateTo: dateTo
        })
        .then(data => checkSession(data));
      if (response.type === 'GET_REPORT_SHOP_GROUP_BY_DAY_DOWNLOAD_SUCCESS') {
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        // setResultMessage('');
        updateLoading(false);
        let csvName = `${timeStamp}_shop_group_by_day.csv`;
        if (typeof account !== 'undefined' && account.fukuokaFlag === 1) {
          csvName = `${timeStamp}_kyoshitsu_group_by_day.csv`;
        }
        downloadCsvBlob(response.payload, csvName);
      } else {
        // setResultMessage('店舗情報ダウンロードに失敗しました。');
        updateLoading(false);
      }
    };

    const showTooltipData = data => {
      if (typeof data.payload !== 'undefined') {
        return (
          <Card className={classes.boxTooltip} elevation="5">
            <div className={classes.labelTooltip}>{data.label}</div>
            {Object.keys(data.payload).length !== 0 &&
              data.payload.map(content => {
                return (
                  <div className={classes.rowTooltip}>
                    <span
                      className={classes.dotColor}
                      style={{ backgroundColor: content.color }}
                    />
                    <span>{content.name}</span>
                    {` : `}
                    <span className={classes.bold}>
                      {content.payload[content.dataKey]}
                    </span>
                  </div>
                );
              })}
          </Card>
        );
      }
      return null;
    };

    const groupDisplayLimit = account.groupDisplayLimit === 1;

    return (
      <div className={classes.root}>
        <MenuDrawerGroup title="サマリーレポート" />
        <main className={classes.content}>
          <div className={classes.toolbar} style={{ display: 'none' }} />

          <Typography variant="h6" noWrap className={classes.title}>
            サマリーレポート
          </Typography>
          <div className={classes.rowTitle}>
            <Typography variant="h6" noWrap className={classes.titleSm}>
              グループ全体
            </Typography>

            <div className={classes.customDateDiv}>
              <div className={classes.normalText}>期間指定:</div>
              <TextField
                label="From"
                type="date"
                onKeyDown={e => e.preventDefault()}
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={dateFrom}
                onChange={e => {
                  setDateFrom(e.target.value);
                  changeDate(e.target.value, dateTo);
                }}
              />
              <TextField
                label="To"
                type="date"
                onKeyDown={e => e.preventDefault()}
                className={classes.textField}
                margin="normal"
                InputLabelProps={{
                  shrink: true
                }}
                value={dateTo}
                onChange={e => {
                  setDateTo(e.target.value);
                  changeDate(dateFrom, e.target.value);
                }}
              />
            </div>
          </div>
          <Paper className={classes.paperWhite}>
            <div className={classes.boxBlueBg}>
              <Typography variant="h6" className={classes.titleSm}>
                {`${dateFrom &&
                  moment(dateFrom, 'YYYY-MM-DD').format('YYYY/MM/DD')}
                ~
                ${dateTo && moment(dateTo, 'YYYY-MM-DD').format('YYYY/MM/DD')}`}
                のサマリーレポート
              </Typography>

              <div className={classes.rowBox}>
                <div className={classes.rowColThree}>
                  <div className={classes.rowInCol}>
                    {!isFukuoka && (
                      <div className={classes.colThreeInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            グループ全体ごち購入額
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.totalAmountWhenBuy
                                ? groupAmountTotal.totalAmountWhenBuy.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                    <div className={classes.colThreeInCol}>
                      <Card className={classes.cardAmount}>
                        <div className={classes.cardHeader}>
                          {isFukuoka
                            ? 'グループ全体利用額'
                            : 'グループ全体ごち利用額'}
                        </div>
                        <CardContent className={classes.cardContent}>
                          <Typography
                            variant="h6"
                            color="textPrimary"
                            className={classes.titleAmount}
                          >
                            {groupAmountTotal.totalAmountWhenUsed
                              ? groupAmountTotal.totalAmountWhenUsed.toLocaleString()
                              : 0}
                            <span className={classes.unit}>円</span>
                          </Typography>
                        </CardContent>
                      </Card>
                    </div>
                    {isGochiKidGroup && (
                      <div className={classes.colThreeInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>合計支援額</div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.totalDonateAmount
                                ? groupAmountTotal.totalDonateAmount.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Paper>

          {isGochiKidGroup && (
            <Paper className={classes.paperWhite}>
              <div className={classes.boxBlueBg}>
                <Typography variant="h6" className={classes.titleSm}>
                  こどもごちめし支援額
                </Typography>

                <div className={classes.rowBox}>
                  <div className={classes.rowColTwo}>
                    <div className={classes.rowInCol}>
                      <div className={classes.colTwoInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>累計支援額</div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.totalDonateAmountAllTime
                                ? groupAmountTotal.totalDonateAmountAllTime.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                      <div className={classes.colTwoInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>支援残額</div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.totalDonateAmountCanUse
                                ? groupAmountTotal.totalDonateAmountCanUse.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Paper>
          )}

          {!isFukuoka && (
            <Paper className={classes.paperWhite}>
              <div className={classes.boxBlueBg}>
                <Typography variant="h6" className={classes.titleSm}>
                  本日(
                  {dateToday}
                  )のサマリーレポート
                </Typography>

                <div className={classes.rowBox}>
                  <div className={classes.rowColTwo}>
                    <div className={classes.rowInCol}>
                      <div className={`${classes.colTwoInCol} ${classes.mb20}`}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            本日のグループ全体ごち購入額
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.amountWhenBuyToday
                                ? groupAmountTotal.amountWhenBuyToday.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                      <div className={`${classes.colTwoInCol} ${classes.mb20}`}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            本日のグループ全体ごち利用額
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.amountWhenUsedToday
                                ? groupAmountTotal.amountWhenUsedToday.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                      <div className={classes.colTwoInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            本日のグループ全体ごち利用者数
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.totalUserUsedGochiToday
                                ? groupAmountTotal.totalUserUsedGochiToday.toLocaleString()
                                : 0}
                              <span className={classes.unit}>人</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                      <div className={classes.colTwoInCol}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            現在のグループ全体未使用ごち額
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {groupAmountTotal.totalAmountGochiUnuse
                                ? groupAmountTotal.totalAmountGochiUnuse.toLocaleString()
                                : 0}
                              <span className={classes.unit}>円</span>
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`${classes.rowColTwo} ${classes.rowColTwoRight}`}
                  >
                    <div className={classes.rowInCol}>
                      <div className={classes.colFull}>
                        <Card className={classes.cardAmount}>
                          <div className={classes.cardHeader}>
                            本日の店舗情報
                          </div>
                          <CardContent className={classes.cardContent}>
                            <Typography
                              variant="h6"
                              color="textPrimary"
                              className={classes.titleAmount}
                            >
                              {openShopGroupTable && (
                                <>
                                  <ShopInGroupTableGroup
                                    roles={roles}
                                    page={pageShopGroup}
                                    handleChangePage={
                                      handleChangeShopGroupToDayPage
                                    }
                                    selectedPage={pageShopGroup}
                                    shopGroup={groupAmountByDay}
                                  />
                                  <ExPaginationGroup
                                    hideRowsPerPage
                                    count={
                                      groupAmountByDay.count %
                                        groupAmountByDay.limit >
                                      0
                                        ? Math.floor(
                                            groupAmountByDay.count /
                                              groupAmountByDay.limit
                                          ) + 1
                                        : Math.floor(
                                            groupAmountByDay.count /
                                              groupAmountByDay.limit
                                          )
                                    }
                                    selectedPage={pageShopGroup}
                                    handleChangePage={
                                      handleChangeShopGroupToDayPage
                                    }
                                    handleChangeRowsPerPage={
                                      handleChangeShopRowsPerPage
                                    }
                                    limit={groupAmountByDay.limit}
                                    totalCount={groupAmountByDay.count}
                                    setLimit={setRowsShopPerPage}
                                  />
                                </>
                              )}
                            </Typography>
                          </CardContent>
                        </Card>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Paper>
          )}

          {/* Chart by Plat form */}
          {!groupDisplayLimit && !isFukuoka && (
            <div
              className={classNames(
                classes.lineDataBlock,
                classes.chartDataFlex
              )}
            >
              <Paper
                className={classNames(
                  classes.dataPaper,
                  classes.dataPaperOneItem
                )}
                elevation={2}
              >
                <Typography
                  component="h2"
                  variant="h5"
                  color="textSecondary"
                  className={classes.titleBar}
                >
                  売上額
                </Typography>
                <ResponsiveContainer width="100%" minWidth="100%" height={300}>
                  <BarChart
                    data={amountShopPlatForm}
                    margin={{
                      top: 20,
                      right: 20,
                      left: 20,
                      bottom: 30
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="createdAt" tick={<CustomizedAxisTick />} />
                    <YAxis />
                    {amountShopPlatForm.length > 0 && (
                      <Tooltip content={showTooltipData} />
                    )}
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{ marginTop: '-20px' }}
                    />
                    <Bar
                      dataKey="amountWhenBuyWeb"
                      name="Web"
                      stackId="a"
                      fill="#8884d8"
                    />
                    <Bar
                      dataKey="amountWhenBuyApp"
                      name="アプリ"
                      stackId="a"
                      fill="#82ca9d"
                    />
                    <Bar
                      dataKey="amountWhenBuyShashoku"
                      name="社食"
                      stackId="a"
                      fill="#cab882"
                    />
                    <Bar
                      dataKey="amountWhenBuyGochiKid"
                      name="こどもごちめし"
                      stackId="a"
                      fill="#FF6666"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Paper>
            </div>
          )}
          {/* Chart by Plat form */}

          {/* Chart by USER TYPE (Amount) */}
          {!groupDisplayLimit && !isFukuoka && (
            <div
              className={classNames(
                classes.lineDataBlock,
                classes.chartDataFlex
              )}
            >
              <Paper
                className={classNames(
                  classes.dataPaper,
                  classes.dataPaperOneItem
                )}
                elevation={2}
              >
                <Typography
                  component="h2"
                  variant="h5"
                  color="textSecondary"
                  className={classes.titleBar}
                >
                  売上額
                </Typography>
                <ResponsiveContainer width="100%" minWidth="100%" height={300}>
                  <BarChart
                    data={amountShopUserType}
                    margin={{
                      top: 20,
                      right: 20,
                      left: 20,
                      bottom: 30
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="createdAt" tick={<CustomizedAxisTick />} />
                    <YAxis />
                    {amountShopUserType.length > 0 && (
                      <Tooltip content={showTooltipData} />
                    )}
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{
                        marginTop: '-20px',
                        width: '60%',
                        left: '50%',
                        transform: 'translateX(-50%)'
                      }}
                    />
                    <Bar
                      dataKey="amountMenuYourself"
                      name="メニュー/自分へのごち"
                      stackId="a"
                      fill="#DB8FAC"
                    />
                    <Bar
                      dataKey="amountMenuAnyone"
                      name="メニュー/オープンごち"
                      stackId="a"
                      fill="#8884D8"
                    />
                    <Bar
                      dataKey="amountMenuUser"
                      name="メニュー/ご指名ごち"
                      stackId="a"
                      fill="#82CA9D"
                    />
                    <Bar
                      dataKey="amountMenuNonuser"
                      name="メニュー/外部ユーザごち"
                      stackId="a"
                      fill="#CAB882"
                    />
                    <Bar
                      dataKey="amountPriceYourself"
                      name="お値段/自分へのごち"
                      stackId="a"
                      fill="#96CCDD"
                    />
                    <Bar
                      dataKey="amountPriceAnyone"
                      name="お値段/オープンごち"
                      stackId="a"
                      fill="#DBDB8B"
                    />
                    <Bar
                      dataKey="amountPriceUser"
                      name="お値段/ご指名ごち"
                      stackId="a"
                      fill="#CA8282"
                    />
                    <Bar
                      dataKey="amountPriceNonuser"
                      name="お値段/外部ユーザごち"
                      stackId="a"
                      fill="#84A5D8"
                    />
                    <Bar
                      dataKey="amountShashoku"
                      name="社食チケット"
                      stackId="a"
                      fill="#CDDA7F"
                    />
                    <Bar
                      dataKey="amountGochiKid"
                      name="こどもごちめし"
                      stackId="a"
                      fill="#FF6666"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Paper>
            </div>
          )}
          {/* Chart by Type of user (Amount) */}

          {/* Chart by USER TYPE (Coupon) */}
          {!groupDisplayLimit && !isFukuoka && (
            <div
              className={classNames(
                classes.lineDataBlock,
                classes.chartDataFlex
              )}
            >
              <Paper
                className={classNames(
                  classes.dataPaper,
                  classes.dataPaperOneItem
                )}
                elevation={2}
              >
                <Typography
                  component="h2"
                  variant="h5"
                  color="textSecondary"
                  className={classes.titleBar}
                >
                  ごちった数
                </Typography>
                <ResponsiveContainer width="100%" minWidth="100%" height={300}>
                  <BarChart
                    data={amountShopUserType}
                    margin={{
                      top: 20,
                      right: 20,
                      left: 20,
                      bottom: 30
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="createdAt" tick={<CustomizedAxisTick />} />
                    <YAxis />
                    {amountShopUserType.length > 0 && (
                      <Tooltip content={showTooltipData} />
                    )}
                    <Legend
                      layout="horizontal"
                      verticalAlign="top"
                      align="center"
                      wrapperStyle={{
                        marginTop: '-20px',
                        width: '60%',
                        left: '50%',
                        transform: 'translateX(-50%)'
                      }}
                    />
                    <Bar
                      dataKey="couponMenuYourself"
                      name="メニュー/自分へのごち"
                      stackId="a"
                      fill="#DB8FAC"
                    />
                    <Bar
                      dataKey="couponMenuAnyone"
                      name="メニュー/オープンごち"
                      stackId="a"
                      fill="#8884D8"
                    />
                    <Bar
                      dataKey="couponMenuUser"
                      name="メニュー/ご指名ごち"
                      stackId="a"
                      fill="#82CA9D"
                    />
                    <Bar
                      dataKey="couponMenuNonuser"
                      name="メニュー/外部ユーザごち"
                      stackId="a"
                      fill="#CAB882"
                    />
                    <Bar
                      dataKey="couponPriceYourself"
                      name="お値段/自分へのごち"
                      stackId="a"
                      fill="#96CCDD"
                    />
                    <Bar
                      dataKey="couponPriceAnyone"
                      name="お値段/オープンごち"
                      stackId="a"
                      fill="#DBDB8B"
                    />
                    <Bar
                      dataKey="couponPriceUser"
                      name="お値段/ご指名ごち"
                      stackId="a"
                      fill="#CA8282"
                    />
                    <Bar
                      dataKey="couponPriceNonuser"
                      name="お値段/外部ユーザごち"
                      stackId="a"
                      fill="#84A5D8"
                    />
                    <Bar
                      dataKey="couponShashoku"
                      name="社食チケット"
                      stackId="a"
                      fill="#CDDA7F"
                    />
                    <Bar
                      dataKey="couponGochiKid"
                      name="こどもごちめし"
                      stackId="a"
                      fill="#FF6666"
                    />
                  </BarChart>
                </ResponsiveContainer>
              </Paper>
            </div>
          )}
          {/* Chart by Type of user (Coupon) */}

          {openShopGroupTable && !groupDisplayLimit && (
            <>
              <div className={classes.rowTitleButton}>
                <Typography variant="h6" noWrap className={classes.title20}>
                  {isFukuoka ? 'グループ教室情報一覧' : 'グループ店舗情報一覧'}
                </Typography>
              </div>

              <div className={classes.titleRow}>
                <ExPaginationGroup
                  hideRowsPerPage
                  count={
                    groupAmountByDayFull.count % groupAmountByDayFull.limit > 0
                      ? Math.floor(
                          groupAmountByDayFull.count /
                            groupAmountByDayFull.limit
                        ) + 1
                      : Math.floor(
                          groupAmountByDayFull.count /
                            groupAmountByDayFull.limit
                        )
                  }
                  selectedPage={pageShopGroupFull}
                  handleChangePage={handleChangeShopGroupFullByDayPage}
                  handleChangeRowsPerPage={handleChangeShopRowsPerPage}
                  limit={groupAmountByDayFull.limit}
                  totalCount={groupAmountByDayFull.count}
                  setLimit={setRowsShopPerPage}
                />
                <div className={classes.marginLeftAuto}>
                  <Button
                    variant="outlined"
                    size="medium"
                    color="primary"
                    bg="white"
                    className={classes.buttonRight}
                    onClick={csvDownloadAction}
                  >
                    エクスポート
                  </Button>
                </div>
              </div>
              <ShopInGroupTableGroup
                shopGroup={groupAmountByDayFull}
                isFullInfo
                isFukuoka={isFukuoka}
              />
              <ExPaginationGroup
                hideRowsPerPage
                count={
                  groupAmountByDayFull.count % groupAmountByDayFull.limit > 0
                    ? Math.floor(
                        groupAmountByDayFull.count / groupAmountByDayFull.limit
                      ) + 1
                    : Math.floor(
                        groupAmountByDayFull.count / groupAmountByDayFull.limit
                      )
                }
                selectedPage={pageShopGroupFull}
                handleChangePage={handleChangeShopGroupFullByDayPage}
                handleChangeRowsPerPage={handleChangeShopRowsPerPage}
                limit={groupAmountByDayFull.limit}
                totalCount={groupAmountByDayFull.count}
                setLimit={setRowsShopPerPage}
              />
            </>
          )}
        </main>
        <ProgressDialog openProgress={openProgress} loading={loading} />
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(SummaryReportGroup));
